var iframeType;
var countdownDate;
var countdownType;
var iframeTypeEnum = {
  ARTICLE: 1,
  SECTION: 2,
};
var countdownTypeEnum = {
  UNTIL_BALLOTS_OPEN: 1,
  UNTIL_BALLOTS_CLOSE: 2,
  VOTES_FINISHED: 3,
};
var predeterminedDates = {
  BALLOTS_OPENING: new Date("March 23, 2021 07:00:00"),
  BALLOTS_CLOSING: new Date("March 23, 2021 22:00:00"),
};

const setIframeType = () => {
  //checks the iframe type
  if (document.querySelector(".article")) {
    iframeType = iframeTypeEnum.ARTICLE;
  } else {
    iframeType = iframeTypeEnum.SECTION;
  }
};

const setCountdownDate = () => {
  const todaysDate = new Date();
  //before ballots opened
  if (todaysDate <= predeterminedDates.BALLOTS_OPENING) {
    countdownType = countdownTypeEnum.UNTIL_BALLOTS_OPEN;
    countdownDate = predeterminedDates.BALLOTS_OPENING;
  }
  //after ballots opened
  else if (todaysDate <= predeterminedDates.BALLOTS_CLOSING) {
    countdownType = countdownTypeEnum.UNTIL_BALLOTS_CLOSE;
    countdownDate = predeterminedDates.BALLOTS_CLOSING;
  }
  //none of the above, finised
  else {
    countdownType = countdownTypeEnum.VOTES_FINISHED;
  }
};
const setElementClasses = () => {
  const rootEl = document.querySelector(".counter");
  if (countdownType == countdownTypeEnum.UNTIL_BALLOTS_OPEN) {
    rootEl.classList.add("before-votes");
  } else if (countdownType == countdownTypeEnum.UNTIL_BALLOTS_CLOSE) {
    rootEl.classList.remove("before-votes");
    rootEl.classList.add("during-votes");
  } else {
    rootEl.classList.remove("during-votes");
    rootEl.classList.add("after-votes");
  }
  console.log(countdownType);
  //debugging
};

const startCounter = () => {
  let interval = setInterval(() => {
    setCountdownDate();

    const daysEl = document.querySelector(".days");
    const hoursEl = document.querySelector(".hours");
    const minutesEl = document.querySelector(".minutes");
    const secondsEl = document.querySelector(".seconds");

    let timeLeft = countdownDate - new Date();

    let days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
    let hours = Math.floor(
      (timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    let minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    let seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
    if (countdownType != countdownTypeEnum.VOTES_FINISHED) {
      daysEl.innerHTML = days.toString().length == 1 ? "0" + days : days;
      hoursEl.innerHTML = hours.toString().length == 1 ? "0" + hours : hours;
      minutesEl.innerHTML =
        minutes.toString().length == 1 ? "0" + minutes : minutes;
      secondsEl.innerHTML =
        seconds.toString().length == 1 ? "0" + seconds : seconds;
    }
    // secondsEl.innerHTML = "00";
    // minutesEl.innerHTML = "00";
    // hoursEl.innerHTML = "00";
    // daysEl.innerHTML = "00";
    setElementClasses();
  }, 1000);
};

const setBannerOnClick = () => {
  const counterEl = document.querySelector(".article");
  if (!counterEl) {
    return;
  }

  counterEl.addEventListener("mousedown", (e) => {
    //allow both middle click and left click
    if (e.which == 1 || e.which == 2) {
      //analytics
      dataLayer = dataLayer || [];
      dataLayer.push({
        event: "GA_Event",
        Category: "Elections 2021",
        Action: "Clicks on iFrames",
      });

      window.open("https://www.ynet.co.il/news/elections2021", "_blank");
    }
  });
};

(function () {
  setIframeType();
  setCountdownDate();
  setElementClasses();
  startCounter();
  setBannerOnClick();
})();
